import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Box
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useAuth } from '../../contexts/AuthContext';
import { getSettings } from '../../services/api';

const Navbar = () => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [registrationEnabled, setRegistrationEnabled] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await getSettings();
        setRegistrationEnabled(response.registrationEnabled);
      } catch (error) {
        console.error('Errore nel caricamento delle impostazioni:', error);
        setRegistrationEnabled(false);
      }
    };
    fetchSettings();
  }, []);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={handleMenu}
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem component={RouterLink} to="/dashboard" onClick={handleClose}>
            Dashboard
          </MenuItem>
          <MenuItem component={RouterLink} to="/profile" onClick={handleClose}>
            Profilo
          </MenuItem>
          { user?.isAdmin && (
            <MenuItem component={RouterLink} to="/admin" onClick={handleClose}>
              Admin Dashboard
            </MenuItem>
          )}
        </Menu>
        <Box 
          component="img"
          src="/images/logo-small.webp"
          srcSet="/images/logo-small.webp, /images/logo-small.png"
          alt="Logo PC Castel Bolognese"
          sx={{ 
            height: 40,
            width: 40,
            mr: 2,
            display: 'block'
          }}
        />
        <Typography variant="h6" component={RouterLink} to="/" sx={{ flexGrow: 1, textDecoration: 'none', color: 'inherit' }}>
          Piattaforma Volontari PC CB
        </Typography>
        <Box>
          {user ? (
            <>
              <Button color="inherit" onClick={logout}>
                Logout
              </Button>
            </>
          ) : (
            <>
              <Button color="inherit" component={RouterLink} to="/login">
                Accedi
              </Button>
              {registrationEnabled && (
                <Button color="inherit" component={RouterLink} to="/register">
                  Registrati
                </Button>
              )}
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;